import React from 'react';
import './Loading.scss';

const Loading = () => {
	return (
		<div className="col-12">
			<div className="snippet" data-title=".dot-pulse">
				<div className="stage">
					<div className="dot-pulse"></div>
				</div>
			</div>
		</div>
	);
};

export default React.memo(Loading);
